import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../redux/axios';

const initialState = {
  Overview: [],
  graphData: [],
  DistributionListData: [],
  statusTabledata: [],
  fileRefrenceData: [],
  AllUserData: [],
  listCount: 0,
  statusCount: 0,
  fileRefCount: 0,
  isFetching: false,
  isSuccess: false,
  isGraphSuccess: false,
  isDistListSuccess: false,
  isTableDataSuccess: false,
  isFileRefSuccess: false,
  isAllUserDataSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getOverview = createAsyncThunk(
  'clerk/dashboard/overview/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/clerk/dashboard/overview/`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const getGraphData = createAsyncThunk(
  'clerk/dashboard/graph/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/clerk/dashboard/graph?customFilter=${udata}`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const getStatusTable = createAsyncThunk(
  'clerk/statusTable/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/clerk/statusTable?${udata}`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const getFileRefrence = createAsyncThunk(
  'clerk/referenceNumber',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/clerk/referenceNumber?${udata}`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);




export const getClerkDistributionList = createAsyncThunk(
  'clerk/distributionList/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      let response = await axios({
        url: `/api/clerk/distributionList?page=${udata}&limit=5`,
        method: 'get',
        headers: {
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const fetchAllUserData = createAsyncThunk(
  'user/viewUser/detailed/',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.get('/api/clerk/collaboratedDoc/new', { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const viewDashboardSlice = createSlice({
  name: 'viewClerkDashboard',
  initialState,
  reducers: {
    clearStateOverview: (state, { payload }) => {
      //state.Overview = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.statusTabledata = [];
      state.isGraphSuccess = false;
      state.isDistListSuccess = false;
      state.isTableDataSuccess = false;
      state.isFileRefSuccess = false;
      state.isError = false;
      state.errorMessage = '';
    },
    clearStateAllUserData: (state, { payload }) => {
      state.AllUserData = [];
      state.isAllUserDataSuccess = false;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
    },
  },

  extraReducers: {
    [getOverview.fulfilled]: (state, { payload }) => {

      state.Overview = payload.data;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getOverview.pending]: (state) => {
      state.isFetching = true;
    },
    [getOverview.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },

    [getGraphData.fulfilled]: (state, { payload }) => {
      state.graphData = payload.data;
      state.isFetching = false;
      state.isGraphSuccess = true;
      return state;
    },
    [getGraphData.pending]: (state) => {
      state.isFetching = true;
    },
    [getGraphData.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },


    [getClerkDistributionList.fulfilled]: (state, { payload }) => {
      state.DistributionListData = payload.data.distributionList;
      state.listCount = payload.data.count;
      state.isFetching = false;
      state.isDistListSuccess = true;
      return state;
    },
    [getClerkDistributionList.pending]: (state) => {
      state.isFetching = true;
    },
    [getClerkDistributionList.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },


    [getStatusTable.fulfilled]: (state, { payload }) => {


      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success == true) {
        state.isTableDataSuccess = true;
        state.statusTabledata = payload.data.data;
        state.statusCount = payload.data.count;
      }
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';
      state.isFetching = false;
      return state;

    },
    [getStatusTable.pending]: (state) => {
      state.isFetching = true;
    },
    [getStatusTable.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
        state.statusTabledata = payload.data;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },


    [getFileRefrence.fulfilled]: (state, { payload }) => {

      // state.listCount = payload.data.count;
      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success) {
        state.isFileRefSuccess = true;
        state.fileRefrenceData = payload.data.data;
        state.fileRefCount = payload.data.count;
      }
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';
      state.isFetching = false;
      return state;

    },
    [getFileRefrence.pending]: (state) => {
      state.isFetching = true;
    },
    [getFileRefrence.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },


    [fetchAllUserData.fulfilled]: (state, { payload }) => {

      state.AllUserData = payload.data;
      state.isFetching = false;
      state.isAllUserDataSuccess = true;
      return state;
    },
    [fetchAllUserData.pending]: (state) => {
      state.isFetching = true;
    },
    [fetchAllUserData.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    },



  },
});

export const { clearStateOverview, clearStateAllUserData } = viewDashboardSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateOverview());
  }
}

export function clearRoomUserData() {

  return async (dispatch) => {
    dispatch(clearStateAllUserData());
  }
}


export const uploadPdfAsyn = (pdata) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.post('/api/clerk/addPdfDocument', pdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    return data;

  } catch (error) {
    return error.response.data;
  }
};

export const viewDashboardSelector = (state) => state.viewClerkDashboard;

export default viewDashboardSlice.reducer;
